import cs from './cs';
import da from './da';
import de from './de';
import en from './en';
import es from './es';
import ca from './ca';
import fr from './fr';
import gr from './gr';
import hu from './hu';
import it from './it';
import lt from './lt';
import ja from './ja';
import nl from './nl';
import nb_no from './nb_no';
import nn_no from './nn_no';
import pl from './pl';
import pt from './pt';
import ro from './ro';
import ru from './ru';
import sv from './sv';
import th from './th';
import tr from './tr';
import uk from './uk';
import vi from './vi';
import zh_Hant from './zh_Hant';
import ko from './ko';
import hr from './hr';
import sl from './sl';
import bg from './bg';
import zh_Hans from './zh_Hans';
import he from './he';

import type { LocalePhrasesRoot } from './types';

export * from './types';

const locales: Record<string, LocalePhrasesRoot> = {
  cs,
  da,
  de,
  en,
  es,
  ca,
  fr,
  gr,
  hu,
  it,
  lt,
  ja,
  nl,
  nb_no,
  nn_no,
  pl,
  pt,
  ro,
  ru,
  sv,
  th,
  tr,
  uk,
  vi,
  zh_Hant,
  ko,
  hr,
  sl,
  bg,
  zh_Hans,
  he,
};

export default locales;
